module.exports = "https://cdn.thelire.com/ins/resource/free_coins_title_icon.2d22e31c64f04c233f55ef41a29a5296.png";